<template>
  <div id="controller" class="maincont">

    <div class="ef--inner">
      <div class="area-info">
        <div class="area-info-label">エリア名称</div>
        <div class="area-info-value">
          <span class="controller-select-box">
            <select id="selected_area_name" v-model="selectedAreaInfo">
              <option v-for="(areaInfo, index) in AreaInfo" v-bind:key="index"
                :value="[areaInfo.area_id, areaInfo.cluster_id]">
                {{ areaInfo.area_name }}
              </option>
            </select>
          </span>
        </div>
      </div>
    </div>

    <div class="ef--inner">
      <h2>制御</h2>
      <div class="controller-list-container">
        <table _fixedhead="rows:1;cols:0;" id="controller-table" class="tfTable">

          <thead>
            <tr>
              <th>No.</th>
              <th cmanFilterBtn>データコード</th>
              <th cmanFilterBtn>名称</th>
              <th>現在値</th>
              <th></th>
              <th>前回の状態変化</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(bcItem, index) in binaryControllInfo" v-bind:key="index">
              <td>{{ index + 1 }}</td>
              <td :id="'bynale_code_' + index">{{ bcItem.dataCode }}</td>
              <td :id="'bynaly_name_' + index">{{ bcItem.dataName }}</td>
              <td>
                <span class="controller-select-box">
                  <select :id="'state_name_' + index" v-model="bcItem.state" @change="changeState(index)">
                    <option :value="true">{{ bcItem.onName }}</option>
                    <option :value="false">{{ bcItem.offName }}</option>
                  </select>
                </span>
              </td>
              <td align="center" title="ボタン押下後、再確認メッセージが表示されます。">
                <button :id="'run_' + index" class="controller-bt" @click="onClickRun(index)" disabled>実行</button>
              </td>
              <td>{{ bcItem.bcStateHistory }}</td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Controller",

  components: {
  },

  data: function () {
    return {
      selectedAreaInfo: [null, null],
      AreaInfo: [],
      binaryControllInfo: [],
    };
  },

  watch: {
    selectedAreaInfo: async function (newVal) {
      await this.getBinaryControll(newVal[0], newVal[1]);
      // eslint-disable-next-line no-undef
      tFilterInit('controller-table');
    }
  },

  mounted: function () {
    this.getAreaInfoControl();
  },

  methods: {
    /* エリア名称全権取得API */
    getAreaInfoControl: async function () {
      await this.$axios
        .get(`/srv/api/area_info/control`, {
          withCredentials: true
        })
        .then(response => {
          this.AreaInfo = response.data.area_infos;
          // グラフ選択で一番上を選択する処理
          this.selectedAreaInfo = [this.AreaInfo[0].area_id, this.AreaInfo[0].cluster_id];
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* 制御情報取得API */
    getBinaryControll: async function (areaId, clusterId) {
      await this.$axios
        .get(`/srv/api/binary_controll/?area_id=${areaId}&cluster_id=${clusterId}`, {
          withCredentials: true
        })
        .then(response => {
          this.binaryControllInfo = response.data.binaryControllInfoList;
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* 制御情報設定API */
    postBinaryControll: async function (param) {
      await this.$axios
        .post(`/srv/api/binary_controll/${this.$store.state.loginID}`, param, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === "success") {
            this.binaryControllInfo = []
            this.getBinaryControll(param.areaId, param.clusterId);
          } else {
            this.reload();
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* 状態変更 実行ボタン アクティブ処理 */
    changeState: function (index) {
      const { value: new_state_name } = document.getElementById(`state_name_${index}`);
      const { binaryControllInfo } = this;
      const { onName, offName, state } = binaryControllInfo[index];
      const run = document.getElementById(`run_${index}`);
      const isOnName = new_state_name === onName;
      const isOffName = new_state_name === offName;

      run.disabled = false;
      if (state && isOnName || !state && isOffName) {
        run.disabled = true;
      }
    },

    /* 状態変更 実行ボタン */
    onClickRun: function (index) {
      if (confirm('実行します。よろしいですか？')) {
        const param = {
          areaId: this.selectedAreaInfo[0],
          clusterId: this.selectedAreaInfo[1],
          dataCode: this.binaryControllInfo[index].dataCode,
          state: !this.binaryControllInfo[index].state,
          onOffNameId: this.binaryControllInfo[index].onOffNameId,
        };
        this.postBinaryControll(param)
      }
    },

    /* ページリロード処理 */
    reload() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
    },
  }
};
</script>

<style scoped>
#controller h2 {
  padding-left: 15px;
  background-color: #5ca1d6;
  color: #fff;
  font-size: 18px;
  height: 45px;
  line-height: 45px;
  border-radius: 4px 4px 0 0;
}

#controller table {
  width: 1202px;
}

#controller thead tr {
  width: 100%;
  background-color: #bcd8ee;
  text-align: center;
  font-size: 13px;
  line-height: 25px;
}

#controller thead th {
  padding: 6px 0;
}

#controller thead th:not(:last-child) {
  border-right: 1px solid #7c8d9d;
}

#controller tbody tr {
  width: 100%;
  background-color: #fff;
  text-align: center;
  line-height: 20px;
}

#controller tbody td {
  padding: 3px 0px;
}

#controller tbody td:not(:last-child) {
  border-right: 1px solid #bdc7d0;
}

.maincont {
  padding-top: 60px;
}

.area-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 10px 20px;
}

.area-info-label {
  margin-right: 20px;
  font-size: 16px;
}

.area-info-value {
  font-size: 16px;
}

.controller-select-box {
  position: relative;
  display: inline-block;
}

.controller-select-box select {
  border: 1px solid #5ca1d6;
  /* padding: 5px 34px 5px 20px; */
  padding: 3px 34px 3px 20px;
  font-size: 14px;
  /* font-size: 14px; */
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  outline: none;
}

.controller-select-box select::-ms-expand {
  display: none;
}

.controller-select-box::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  content: '';
  background-color: #9fc8e7;
  pointer-events: none;
  z-index: 99;
}

.controller-select-box::after {
  position: absolute;
  top: -4px;
  bottom: 0;
  right: 6px;
  margin: auto;
  content: "";
  vertical-align: middle;
  width: 8px;
  height: 8px;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  z-index: 99;
}

.controller-list-container {
  overflow: auto;
  width: auto;
  /* max-height: 150px; */
  max-height: 650px;
  margin-bottom: 20px;
}

.controller-list tr:not(:last-child) {
  border-bottom: 1px solid #bdc7d0;
}

@media screen and (max-width: 1102px) {

  .controller-list-container {
    width: 100%;
  }

}

.controller-bt {
  display: block;
  background-color: #5ca1d6;
  border: none;
  border-radius: 4px;
  width: 75px;
  padding: 5px 20px;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

.controller-bt:disabled {
  background-color: #91a1af;
}

.controller-bt:disabled:hover {
  background-color: #91a1af;
}

.controller-bt:hover {
  background-color: #005cc0;
}
</style>